module.exports = __webpack_public_path__ + "media/images/icon__betPick--pick-b2c4c48e0a510edb82823bb730ee2529.png";